import axios from "axios";
import store from "../Redux/Store";
import { showError } from "../Redux/ErrorBoundary/ErrorBoundaryActions";
import { AppError } from "../Types/AppError";
import { buildAppError } from "../Utils/AppError";

const axiosInstance = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Ignore aborted/canceled requests
    if (axios.isCancel(error)) {
      return Promise.reject(error);
    }

    // Allow callers to opt out of global error popup
    const cfg: any = error?.config || {};
    if (cfg.skipGlobalErrorHandler) {
      return Promise.reject(error);
    }

    const appError: AppError = buildAppError(
      error,
      "Please reload the page and try again."
    );

    store.dispatch(showError(appError));
    return Promise.reject(error);
  }
);

export default axiosInstance;
